if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
      }
      this.mql = window.matchMedia('(min-width: 750px)');
      if (!this.elements.thumbnails) return;

      // Store the currently active media ID (to revert to on hover leave)
      this.activeMediaId = this.elements.viewer.querySelector('[data-media-id].is-active')?.dataset.mediaId;

      this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
      this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
        const button = mediaToSwitch.querySelector('button');
        
        // Click to set active thumbnail
        button.addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        
        // Hover to preview thumbnail (without changing active state)
        button.addEventListener('mouseenter', this.onThumbnailHover.bind(this, mediaToSwitch.dataset.target));
        
        // Mouse leave to revert to active thumbnail
        button.addEventListener('mouseleave', this.onThumbnailLeave.bind(this));
      });
      if (this.dataset.desktopLayout !== 'stacked' && this.mql.matches) this.removeListSemantic();
      this.setupThumbnailHoverScroll();
    }

    // Handle thumbnail hover - show preview without changing active state
    onThumbnailHover(mediaId) {
      const hoverMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`);
      if (!hoverMedia) return;

      // Hide all media
      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });

      // Show hovered media
      hoverMedia.classList.add('is-active');
      this.playActiveMedia(hoverMedia);
    }

    // Handle mouse leave - revert to the actual active thumbnail
    onThumbnailLeave() {
      // Find the button that has aria-current="true" (the actual active one)
      const activeThumbnail = this.elements.thumbnails.querySelector('[data-target] button[aria-current="true"]');
      
      if (activeThumbnail) {
        const activeMediaId = activeThumbnail.closest('[data-target]').dataset.target;
        const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${activeMediaId}"]`);
        
        if (activeMedia) {
          // Hide all media
          this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
            element.classList.remove('is-active');
          });
          
          // Show the active media
          activeMedia.classList.add('is-active');
          this.playActiveMedia(activeMedia);
        }
      }
    }

    onSlideChanged(event) {
      const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${ event.detail.currentElement.dataset.mediaId }"]`);
      this.setActiveThumbnail(thumbnail);
    //  if(!$(event.detail.currentElement).hasClass('hide-mob')){
    //   $(".slider-mobile-gutter li.hide-mob").hide();
    //  }
    
    }

    setActiveMedia(mediaId, prepend) {
      // Update stored active media ID
      this.activeMediaId = mediaId;

      const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${ mediaId }"]`);
      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });
      if(activeMedia){
        activeMedia.classList.add('is-active');
      }
      if (prepend) {
        if(activeMedia){
          activeMedia.parentElement.prepend(activeMedia);
        }
        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
          if(activeThumbnail){
            activeThumbnail.parentElement.prepend(activeThumbnail);
          }
        }
        if (this.elements.viewer.slider) this.elements.viewer.resetPages();
      }

      this.preventStickyHeader();
      window.setTimeout(() => {
        if (this.elements.thumbnails) {
          if(activeMedia){
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
        }
        if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
          if(activeMedia){
            activeMedia.scrollIntoView ({behavior: 'smooth'});
          }
        }
      });
      this.playActiveMedia(activeMedia);

      if (!this.elements.thumbnails) return;
      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
      if(activeThumbnail){
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }
    }

    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;

      this.elements.thumbnails.querySelectorAll('button').forEach((element) => element.removeAttribute('aria-current'));
      thumbnail.querySelector('button').setAttribute('aria-current', true);
      if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

      this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
    }

    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image) return;
      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);
        this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
          '[index]',
          position
        );
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };
      image.src = image.src;
    }

    playActiveMedia(activeItem) {
      if(!activeItem){
        return;
      }
      window.pauseAllMedia();
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia) deferredMedia.loadContent(false);
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
  if (!this.elements.viewer.slider) return;
  this.elements.viewer.slider.setAttribute('role', 'presentation');
  this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
  
  // ADD THIS — disable thumbnail slider snap behavior
  if (this.elements.thumbnails) {
    const thumbList = this.elements.thumbnails.querySelector('.thumbnail-list');
    if (thumbList) {
      thumbList.style.setProperty('scroll-snap-type', 'none', 'important');
      thumbList.style.setProperty('overflow-x', 'auto', 'important');
    }
  }
}
        setupThumbnailHoverScroll() {
      if (!this.elements.thumbnails) return;

      const thumbnailSlider = this.elements.thumbnails;
      
    }
  });
}

